// extracted by mini-css-extract-plugin
export default {"AdvancedToggle":"AdvancedToggle_t6NqB_v17-8-1","Content":"Content_C0u0z_v17-8-1","AdvancedToggle__isOpen":"AdvancedToggle__isOpen_HlJzt_v17-8-1","Toggle":"Toggle_dJKJv_v17-8-1"};